import React, { CSSProperties, PropsWithChildren, useMemo } from 'react';

import { colors } from '@/colors';

interface ITextWithHighlightingProps extends PropsWithChildren {
  hideIfNoHighlighting?: boolean;
  useEllipsis?: boolean;
  searchValue?: string;
  style?: CSSProperties;
}

export const TextWithHighlighting = ({
  style = {},
  children,
  searchValue,
  useEllipsis = false,
  hideIfNoHighlighting = false,
}: ITextWithHighlightingProps) => {
  const searchValueRegExpPrepared = useMemo(
    () => (searchValue ? new RegExp(`(${searchValue.split('').join('-?\\s*')})`, 'i') : undefined),
    [searchValue]
  );

  let formattedValue = children;

  if (typeof children === 'string' && searchValueRegExpPrepared) {
    const segments = children.split(searchValueRegExpPrepared);
    const haveAtLeastOneOccurrence = segments.length > 1;
    if (haveAtLeastOneOccurrence) {
      formattedValue = (
        <>
          {segments.map((s, index) => {
            return (
              <span
                key={`segment-${children}-${s}-${index}`}
                style={{ backgroundColor: searchValueRegExpPrepared.test(s) ? colors.secondary : 'transparent' }}
              >
                {s}
              </span>
            );
          })}
        </>
      );
    } else if (hideIfNoHighlighting) {
      return null;
    }
  }
  return (
    <span
      className={useEllipsis ? 'text-with-highlighting one-line-ellipsis' : 'text-with-highlighting'}
      style={{ textAlign: 'left', ...style }}
    >
      {formattedValue}
    </span>
  );
};
